import { Injectable } from "@angular/core";
import { AppConfig } from "../helpers/app.config";

declare const d365mktformcapture: any;

function attachScript(src: string): HTMLScriptElement {
  const scriptEl: HTMLScriptElement = document.createElement("script");
  scriptEl.src = src;
  return document.head.appendChild(scriptEl);
}

/**
 * Will interacts with Microsoft Dynamics 365 to send the submitted form as lead
 * to the crm.
 */
@Injectable({ providedIn: "root" })
export class MarketingCrmService {
  constructor() {}
  public attachFormTracker(): void {
    if (!AppConfig.connection.marketingCrm) {
      return;
    }

    const d365 = AppConfig.connection.marketingCrm.d365;
    if (d365) {
      attachScript(d365.scriptUrl);
    }
  }

  public prepareForm(formSelector: string): void {
    const captureConfig = AppConfig.connection.marketingCrm?.d365?.captureConfig;
    if (!captureConfig) {
      return;
    }

    // NOTE: for reference see https://go.microsoft.com/fwlink/?linkid=2250770
    d365mktformcapture
      .waitForElement(formSelector) // example: "#form1" as a selector for form with id="form1"
      .then((form) => {
        const mappings = [
          {
            FormFieldName: "email",
            DataverseFieldName: "emailaddress1"
          },
          {
            FormFieldName: "phoneNumber",
            DataverseFieldName: "telephone1"
          },
          {
            FormFieldName: "ags",
            DataverseFieldName: "itvt_ags_account"
          },
          {
            FormFieldName: "text",
            DataverseFieldName: "description"
          },
          {
            FormFieldName: "givenName",
            DataverseFieldName: "firstname"
          },
          {
            FormFieldName: "familyName",
            DataverseFieldName: "lastname"
          },
          {
            FormFieldName: "communicationType",
            DataverseFieldName: "preferredcontactmethodcode",
            DataverseFieldValue: [
              //{ FormValue: "***Please fill***", DataverseValue: "1" }, // Beliebig
              { FormValue: "email", DataverseValue: "2" }, // E-Mail
              { FormValue: "phone", DataverseValue: "3" } // Telefon
              //{ FormValue: "***Please fill***", DataverseValue: "4" }, // Fax
              //{ FormValue: "***Please fill***", DataverseValue: "5" } // Post
            ]
          },
          {
            FormFieldName: "moduleMarketingGuid",
            DataverseFieldName: "itvt_guid_product"
          }
        ];

        form.addEventListener(
          "submit",
          (e) => {
            e.preventDefault();

            const serializedForm = d365mktformcapture.serializeForm(form, mappings);
            const moduleMarketingGuid = serializedForm.SerializedForm.get("itvt_guid_product");
            if (!moduleMarketingGuid?.value) {
              // don't send there is no moduleMarketingGuid defined for this module.
              return false;
            }

            const payload = serializedForm.SerializedForm.build();
            d365mktformcapture.submitForm(captureConfig, payload).catch((error) => {
              console.error("Error submitting form to Dynamics365 CRM:", error);
            });
            return false;
          },
          true
        );
      });
  }
}
